import React from "react";
import { MovingWebsite } from "../../components/UnderConstruction";
import { InstaEmbedRow } from "../../components/Embeds/components/embeds/EmbedRow";

export function artdigital() {
return ( 
 <>
<div className="row">
<div className="col"><MovingWebsite/>
</div>
</div>
<InstaEmbedRow
    url1="https://www.instagram.com/p/CfH1-xCvU6z"
    url2="https://www.instagram.com/p/CfB5WK2KY4k"
    url3="https://www.instagram.com/p/Ceic_dyK2ge"
/>
<InstaEmbedRow
    url1="https://www.instagram.com/p/CfXQZaKLTls"
    url2="https://www.instagram.com/p/CdTmOhsqffM"
    url3="https://www.instagram.com/p/CjjUPsqqbnV"
/>
<InstaEmbedRow
    url1="https://www.instagram.com/p/CinTsHSuAxs"
    url2="https://www.instagram.com/p/CjNsJh0Olxt"
    url3="https://www.instagram.com/p/ClLDHrJuimZ"  
/>
<InstaEmbedRow
    url1="https://www.instagram.com/p/CmeF7fJqZCw"
    url2="https://www.instagram.com/p/"
    url3="https://www.instagram.com/p/"
/>
</>
);
}

/* 
<InstaEmbedRow
    url1="https://www.instagram.com/p/"
    url2="https://www.instagram.com/p/"
    url3="https://www.instagram.com/p/"
/>

<PintEmbedRow
    url1="https://www.pinterest.de/pin/"
    url2="https://www.pinterest.de/pin/"
    url3="https://www.pinterest.de/pin/"
/>
 */
